import { FetchBaseQueryError } from "@reduxjs/toolkit/query";

type ErrorResponse = {
  path: string;
  status: number;
  title: string;
  detail: string;
  code: string;
  requestId: string;
  callstack?: string;
  exception?: string;
};

export type ErrorData = {
  title: string;
  detail: string;
  code: string;
  requestId: string;
};

export function transformResponseToErrorData(
  errorResponse: FetchBaseQueryError
): FetchBaseQueryError {
  const errorResponseData: ErrorResponse =
    errorResponse.data as unknown as ErrorResponse;
  const error: FetchBaseQueryError = {
    status: errorResponseData.status,
    data: {
      title: errorResponseData.title,
      detail: errorResponseData.detail,
      code: errorResponseData.code,
      requestId: errorResponseData.requestId,
    } as ErrorData,
  };
  return error;
}
